import React, { useEffect, useRef, useState } from 'react';

import cn from 'classnames';
import useEmblaCarousel from 'embla-carousel-react';

import ArrowLeft from '../Icons/ArrowLeft';
import { useMediaQuery } from '@mui/material';

export default function VideoExamples({ items, btnStyles }) {
  const [emblaRef, emblaApi] = useEmblaCarousel();
  const isTablet = useMediaQuery("(max-width: 1024px)");
  const [current, setCurrent] = useState(emblaApi?.selectedScrollSnap() || 0);
  const [isPrevDisabled, setIsPrevDisabled] = useState(true);
  const [isNextDisabled, setIsNextDisabled] = useState(false);
  const [isUserPerformAction, setIsUserPerformAction] = useState(false);

  const timeoutRef = useRef(null);

  function onUserActions() {
    setIsUserPerformAction(true);
    setTimeout(() => setIsUserPerformAction(false), 30000);
  }

  function scrollNext() {
    emblaApi?.scrollNext();
    onUserActions();
  }

  function scrollPrev() {
    emblaApi?.scrollPrev();
    onUserActions();
  }

  function trackChanges() {
    setCurrent(emblaApi?.selectedScrollSnap());

    setIsPrevDisabled(!emblaApi?.canScrollPrev());
    setIsNextDisabled(!emblaApi?.canScrollNext());
  }

  function handleAuto(delay) {
    if (isTablet) return;
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    let newState = current === 0 ? 1 : 0;

    if (isUserPerformAction) {
      delay += 30000;
    }

    timeoutRef.current = setTimeout(() => {
      emblaApi.scrollTo(newState);
    }, delay);
  }

  useEffect(() => {
    let delay = 16000;

    handleAuto(delay);
  }, [current, emblaApi]);

  useEffect(() => {
    if (emblaApi) {
      emblaApi.on('scroll', trackChanges).on('init', trackChanges).on('reInit', trackChanges);
    }
  }, [emblaApi]);

  useEffect(() => {
    if (isTablet) return;
    if (current !== 0) return;
    if (document.hidden) return;
    const firstVideo = document.querySelector('#video-0');

    const secondPlay = setInterval(() => {
      firstVideo.play();
    }, 10000);

    return () => {
      clearInterval(secondPlay);
    };
  }, []);

  return (
    <div className="static mt-6 w-full min-1100:hidden">
      <div className="relative aspect-video w-full">
        <div ref={emblaRef} className="embla relative w-full overflow-hidden">
          <div className="embla__container flex w-full gap-5">
            {items.map((item, index) => (
              <div key={index} className="embla__slide min-w-full basis-full" onTouchStart={() => onUserActions()}>
                <video
                  id={isTablet ? 'vv' : `video-${current}`}
                  key={item.video}
                  autoPlay
                  playsInline
                  muted
                  loop={current === 1}
                  className="min-w-full bg-transparent"
                >
                  <source  src={item.video}></source>
                </video>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="z-[12] flex max-w-full gap-5 1100:mx-auto 1100:max-w-[50%] sm:max-w-full">
        <div className="progress relative flex w-full items-center">
          <div
            style={{ width: `calc(100%/${items.length}`, translate: `calc(100%*${current})` }}
            className="absolute h-[7px] bg-demo-xr-blue transition-all duration-500"
          />
          <hr className="w-full" />
        </div>
        <div className="flex gap-2">
          <button
            disabled={isPrevDisabled}
            className={cn(btnStyles, 'disabled:cursor-not-allowed disabled:opacity-50')}
            onClick={scrollPrev}
          >
            <ArrowLeft className="h-full w-full fill-white group-hover:fill-demo-xr-blue group-disabled:!fill-white" />
          </button>
          <button
            disabled={isNextDisabled}
            className={cn(btnStyles, 'disabled:cursor-not-allowed disabled:opacity-50')}
            onClick={scrollNext}
          >
            <ArrowLeft className="h-full w-full rotate-180 fill-white group-hover:fill-demo-xr-blue group-disabled:!fill-white" />
          </button>
        </div>
      </div>
    </div>
  );
}
